import {SectionHeader} from "./SectionHeader";
import {ChakraImage} from "../../utility/ChakraImage";

const TEAM = [
    {

        picture: "/bilder/GabrieleWagner.jpg",
        name: "Praxisinhaberin Gabriele Wagner",
        role: "Fachärztin für Allgemeinmedizin, Notfallmedizin und Naturheilverfahren",
        bio: "Über 20 Jahre Erfahrung in der hausärztlichen Versorgung"
    },
    {
        initials: "CW",
        name: "Christiana Wirth",
        role: "Medizinische Fachangestellte",
        bio: "Seit über 20 Jahren ein Team"
    },
];

export function Team() {
    return (
        <section id="team" className="section">
            <SectionHeader title="Unser Team"/>
            <div className="team-grid">
                {TEAM.map(({picture, initials, name, role, bio}) => (
                    <div className="team-member" key={name}>
                        {initials ? <div className="avatar">{initials}</div>
                            : <div className="picture"><ChakraImage picturePath={picture} name={name}/></div>}
                        <div className={initials ? "" : "infoBox"}>
                            <div className={`member-info`}>
                                <h3>{name}</h3>
                                <div className={`member-role ${initials ? "" : "member-role2"}`}>{role}</div>
                                <p className="memberu-bio">{bio}</p>
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </section>
    );
}